import React, { useCallback, useState, useRef, useEffect, useMemo, forwardRef, useContext } from 'react';
import DefaultEditor from '@components/Global/EmailBuilder/CustomEditor';
import { useQueryClient } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import grapesjs, { usePlugin } from 'grapesjs';
import SmartSaaSPlugin from '@components/Global/EmailBuilder/Components/SmartSaaSPlugin';
import ImagePlugin from '@components/Global/EmailBuilder/Components/ImagePlugin';
import AssetPlugin from '@components/Global/EmailBuilder/Components/AssetPlugin';
import ShareLinksPlugin, { createShareLinkFetchers } from '@components/Global/EmailBuilder/Components/ShareLinksPlugin';
import GjsEditor, { AssetsProvider, Canvas, useEditor } from '@grapesjs/react';
import { gjsOptions } from '@components/Global/EmailBuilder/CustomEditor';
import styles from '@stylesheet';
import { Alert, Platform, View } from 'react-native';
import AnimatedLottieView from '@utils/lottieAnimation';
import { useNavigation } from '@react-navigation/native';
import { RichEditorProps } from 'react-native-pell-rich-editor';
import { HIDE_TOOLBAR } from '@reduxLocal/actions/types';
import { DefaultRootState } from '@reduxLocal/persistState';

const NewCreativeTemplate = ({ route }) => {
  const templateId = route.params?.templateId;
  const [showGlobalAssets, setShowGlobalAssets] = useState(false);
  const navigation = useNavigation();
  const [canGoBack, setCanGoBack] = useState(false);
  const editorRef = useRef<RichEditorProps>(null);
  const [showHelp, setShowHelp] = useState(false);
  const [flip, setFlip] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editorState, setEditorState] = useState(null);
  const [previewState, setPreviewState] = useState();
  const [templateTitle, setTemplateTitle] = useState("");
  const [templateDescription, setTemplateDescription] = useState("");
  const [templateTags, setTemplateTags] = useState([]);
  const queryClient = useQueryClient();
  const [initialState, setInitialState] = useState(null);
  const dispatch = useDispatch();
  const selectedProfileId = useSelector((state: DefaultRootState) => state.app.selectedProfile?.id);
  const fallbackUserId = useSelector((state: DefaultRootState) => state.promiseData?.data?.userData?.id);
  const shareLinkFetchers = useMemo(
    () => createShareLinkFetchers({ userId: selectedProfileId || fallbackUserId }),
    [selectedProfileId, fallbackUserId],
  );
  const [gjsOptionsState, setGjsOptions] = useState(gjsOptions);
  const [grapesjsCss, setGrapesjsCss] = useState('');


  
  const handleBeforeRemove = (e) => {
    if (!canGoBack) {
      e.preventDefault();
      console.warn('preventing page change');
      if (Platform.OS === 'web') {
        //Create alert for web
        if (window.confirm('You have unsaved changes. Are you sure to discard them and leave the screen?')) {
          navigation.dispatch(e.data.action);
          dispatch({ type: HIDE_TOOLBAR });
        }
      } else {
        Alert.alert(
          'Discard changes?',
          'You have unsaved changes. Are you sure to discard them and leave the screen?',
          [
            { text: "Don't leave", style: 'cancel', onPress: () => { } },
            {
              text: 'Discard',
              style: 'destructive',
              onPress: () => {
                navigation.dispatch(e.data.action);
                dispatch({ type: HIDE_TOOLBAR });
              },
            },
          ]
        );
      }
    }
  };

    useEffect(
      () => {
        const beforeRemoveListener = navigation.addListener('beforeRemove', handleBeforeRemove);
  
        return () => {
          beforeRemoveListener();
        }
      },
      [navigation, editorRef]
    );

  return (
    <View style={{ flex: 1, alignSelf: 'stretch', minHeight: "100%" }}>
      <View style={[styles.face, { flex: 1, gap: 30, alignSelf: "stretch", minHeight: "100%" }]}>
        {
          loading ?
            <AnimatedLottieView source={require('@assets/animations/leaf_Loader.json')} style={{ width: '100%', height: '100%' }} autoPlay />
            :
            <GjsEditor
              grapesjs={grapesjs}
              grapesjsCss={grapesjsCss}
              options={gjsOptionsState}
              plugins={[
                usePlugin(SmartSaaSPlugin, {}),
                usePlugin(ShareLinksPlugin, { fetchers: shareLinkFetchers }),
                usePlugin(ImagePlugin, {}),
                usePlugin(AssetPlugin, {}),
              ]}
            >
              <DefaultEditor type={"image"} loadCallback={setGjsOptions} initialData={initialState} />
            </GjsEditor>
        }
      </View>
    </View>
  )
};
export default NewCreativeTemplate;